import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param tenantId
 * @param payload
 * @param poId
 */
class PurchaseOrderServices {
  /**
     * @param {*} firstSubUrl
     * @param {*} secondSubUrl
     * @param {*} orgId
     * @param {*} tenantIds
     * @param {*} fromDate
     * @param {*} toDate
     * @param fileReportType
     * @param reportName
     * @param {*} type
     * @param {*} sellerId
     * @return
     */
  downloadPOData = async (payload) => {
    const poData = await Helpers.post({
      url: Constants.PURCHASE_ORDERS_DOWNLOAD_DATA,
      data: payload,
    });
    return poData;
  }

  /**
   * @param page
   * @param orgId
   * @param poId
   * @param tenantId
   * @param sellerId
   * @param tenantSellerId
   * @param onDate
   * @param fromDate
   * @param toDate
   * @param limit
   * @param roleId
   * @param poNumber
   * @param searchKeyword
   * @param status
   * @param poReceivingStatus
   * @return {Promise<*>}
   */
  getPurchaseOrders = async (orgId, tenantId, tenantSellerId, poId, onDate, fromDate, toDate, status, page, limit, roleId, poNumber, searchKeyword, poReceivingStatus, expiryStartDate, expiryEndDate, paymentStatus, edd, productSearch, mrpId, tags, departmentIds, excludeMrpLinked, destinationTenantId, isListScreen, excludeJobWorksPo, excludeSubcontractorPo, linkedPoIds) => {
    let url = `${Constants.PURCHASE_ORDERS}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (isListScreen) url += `is_list=${isListScreen}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (tenantSellerId) url += `tenant_seller_id=${tenantSellerId}&`;
    if (destinationTenantId) url += `destination_tenant_id=${destinationTenantId}&`;
    if (poId) url += `po_id=${poId}&`;
    if (onDate) url += `on_date=${onDate}&`;
    if (fromDate) url += `from_date=${fromDate}&`;
    if (toDate) url += `to_date=${toDate}&`;
    if (status) url += `status=${status}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (roleId) url += `tenant_role_id=${roleId}&`;
    if (poNumber) url += `po_number=${poNumber}&`;
    if (paymentStatus) url += `payment_status=${paymentStatus}&`;
    if (poReceivingStatus) url += `po_receiving_status=${poReceivingStatus}&`;
    if (expiryStartDate) url += `expiry_start_date=${expiryStartDate}&`;
    if (edd) url += `edd=${edd}&`;
    if (expiryEndDate) url += `expiry_end_date=${expiryEndDate}&`;
    if (productSearch) url += `product_sku_ids=${productSearch}&`;
    if (mrpId) url += `mrp_id=${mrpId}&`;
    if (tags) url += `tags=${tags}&`;
    if (departmentIds) url += `department_ids=${departmentIds}&`
    if (excludeMrpLinked) url += `exclude_mrp_linked=${excludeMrpLinked}&`
    if (excludeJobWorksPo) url += `exclude_job_works_po=${excludeJobWorksPo}&`
    if (excludeSubcontractorPo) url += `exclude_subcontractor_po=${excludeSubcontractorPo}&`
    if (linkedPoIds) url += `linked_po_ids=${linkedPoIds}&`
    const orgPos = await Helpers.get({ url });
    return orgPos;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  createPurchaseOrder = async (payload) => {
    const addedProduct = await Helpers.post({
      url: Constants.PURCHASE_ORDERS,
      data: payload,
    });
    return addedProduct;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  updatePurchaseOrder = async (payload) => {
    const addedProduct = await Helpers.put({
      url: Constants.PURCHASE_ORDERS,
      data: payload,
    });
    return addedProduct;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
  approvePO = async (payload) => {
    const po = await Helpers.put({
      url: Constants.APPROVE_PO,
      data: payload,
    });
    return po;
  }

  /**
   *
   * @param {*} startDate
   * @param {*} endDate
   * @param {*} tenantId
   * @param {*} sellerId
   * @param {*} orgId
   * @return
   */
  getPOAnalytics = async (startDate, endDate, tenantId, sellerId, orgId) => {
    const purchaseData = await Helpers.get({
      url: `${Constants.GET_PO_ANALYTICS}?start_date=${startDate || ''}&end_date=${endDate || ''}&tenant_id=${tenantId || ''}&seller_id=${sellerId || ''}&org_id=${orgId || ''}`,
    });
    return purchaseData;
  }

  /**
   * @param poId
   * @param tenantId
   * @return {Promise<*>}
   */
  getPurchaseOrderById = async (poId, tenantId) => {
    const selectedPo = await Helpers.get({
      url: `${Constants.PURCHASE_ORDERS}?po_id=${poId}&tenant_id=${tenantId}`,
    });
    return selectedPo;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  updatePoStatus = async (payload) => {
    const updatedPo = await Helpers.post({
      url: Constants.UPDATE_PO_STATUS,
      data: payload,
    });
    return updatedPo;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  updatePurchaseOrderExpiryDate = async (payload) => {
    const updatePoExpiryDate = await Helpers.put({
      url: Constants.UPDATE_PO_EXPIRY_DATE,
      data: payload,
    });
    return updatePoExpiryDate;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  updatePoWorkflowStep = async (payload) => {
    const updatedWorkflow = await Helpers.post({
      url: Constants.UPDATE_PO_WORKFLOW_STEP,
      data: payload,
    });
    return updatedWorkflow;
  }

  /**
   *
   * @param tenantId
   * @return {Promise<*>}
   */
  getPoSequence = async (tenantId) => {
    const poSquence = await Helpers.get({
      url: `${Constants.GET_PO_SEQUENCE}?tenant_id=${tenantId}`,
    });
    return poSquence;
  }

  /**
   *
   * @param payload
   * @return {Promise<void>}
   */
  updatePoSequence = async (payload) => {
    const updatedPoSequence = await Helpers.post({
      url: Constants.GET_PO_SEQUENCE,
      data: payload,
    });
    return updatedPoSequence;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  deletePurchaseOrder = async (payload) => {
    const deletePurchaseOrder = await Helpers.delete({
      url: Constants.PURCHASE_ORDERS,
      data: payload,
    });
    return deletePurchaseOrder;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  sendPoMailToVendor = async (payload) => {
    const url = `${Constants.PURCHASE_ORDERS}/send_mail`;
    const vendorMail = await Helpers.post({
      url,
      data: payload,
    });
    return vendorMail;
  }

  /**
   *
   * @param payload
   * @returns {Promise<*>}
   */
  closePo = async (payload) => {
    const url = `${Constants.PURCHASE_ORDERS}/close`;
    const updatedPo = await Helpers.put({
      url,
      data: payload,
    });
    return updatedPo;
  }

  /**
   *
   * @param payload
   * @returns {Promise<*>}
   */
  sendPoWhatsapp = async (payload) => {
    const url = `${Constants.PURCHASE_ORDERS}/send_whatsapp`;
    const sendWhatsapp = await Helpers.post({
      url,
      data: payload,
    });
    return sendWhatsapp;
  }
}
export default new PurchaseOrderServices();
